<template>
  <div class="pos-list-item p-d-flex p-flex-row p-flex-nowrap p-jc-between p-ai-stretch" :class="{selected: selected}">
    <div class="pos-details p-p-3">
      <div class="p-d-flex p-flex-row p-flex-nowrap p-jc-between p-ai-stretch">
        <div class="p-grid" style="width: 100%;">
          <div class="pos-name p-py-0 p-py-md-2 p-col-8 p-d-flex p-ai-center"><div class="pos-city p-d-block p-d-md-inline" :class="{'pos-city--selected': selected}" v-html="attributes.name"></div></div>
          <div class="pos-distance p-px-0 p-px-md-2 p-py-0 p-py-md-2 p-col-4" style="text-align: right" v-if="attributes.userPositionDistance">
            <i class="pi pi-flag p-mr-2"></i>
            <strong>{{ distanceStr }}</strong>
          </div>
          <div class="pos-address p-col-12 p-pb-0 p-mb-md-3"><span v-if="attributes.street_address && attributes.street_address !== 'undefined'">{{ attributes.street_address }} - </span>{{ attributes.postal_code }} {{ attributes.locality }}</div>
          <div class="pos-phone p-col-12 p-pt-0 p-pb-2 p-d-block p-d-md-none p-mb-1">{{ attributes.phone }}</div>
          <div class="p-d-flex">
            <a :href="`tel:${attributes.phone.replace(/\s+/g, '')}`" title="Appelez-nous" target="_blank" class="p-d-none p-d-md-block p-button p-button-secondary rounded-button p-mr-2 p-px-2 p-px-md-4">{{attributes.phone}}</a>
            <a :href="`tel:${attributes.phone.replace(/\s+/g, '')}`" title="Appelez-nous" target="_blank" style="height: 2.5rem;" class="p-d-flex p-jc-center p-d-md-none p-button p-button-secondary rounded-button p-mr-2 p-px-2 p-px-md-4">
              <i class="pi pi-phone p-mr-1"></i> Appeler
            </a>
            <a href="#" @click.prevent="onBookClick" title="Je prends rendez-vous" class="book-button p-d-flex p-button p-button-primary rounded-button p-px-2 p-px-md-4">Prenez rendez-vous</a>
          </div>
        </div>
      </div>
    </div>
    <a class="pos-info-icon p-d-flex p-flex-column p-flex-nowrap p-jc-center p-ai-center" @click="displayMarker">
      <i class="pi pi-info-circle" style="font-size: 1.6rem;"></i>
    </a>
  </div>
</template>

<script>
// import Cookies from 'js-cookie'

export default {
  name: "PosListItem",
  props: {
    pos: {
      type: Object,
      default: () => {
        return {
          properties: {}
        }
      }
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    attributes () {
      return this.pos && this.pos.properties ? this.pos.properties : {
        phone: '',
        locality: '',
        company_id: ''
      }
    },
    distanceStr () {
      return this.attributes.userPositionDistance.toFixed(1) + ' km'
    }
  },
  methods: {
    displayMarker() {
      this.$emit('display-pos-marker', this.pos);
    },

    onBookClick() {
      // Cookies.set('preselectedCenter', this.attributes.company_id, { expires: 365, path: '/' })
      localStorage.company_id = this.attributes.company_id
      const redirectTarget = document.body.dataset.storeLocatorBookingPagePermalink
      window.location.href = redirectTarget
    }
  }
}
</script>

<style scoped>
.pos-list-item {
  -webkit-box-shadow: var(--webkit-box-shadow-bottom);
  -moz-box-shadow: var(--moz-box-shadow-bottom);
  box-shadow: var(--box-shadow-bottom);
  border-bottom: solid 1px var(--123-light-grey);
}

@media screen and (min-width: 720px) {
  .pos-list-item {
    min-height: 160px;
  }
}
.pos-list-item .pos-details {
  flex-grow: 0;
  flex-basis: 90%;
}
.pos-list-item .pos-details .pos-name {
  text-transform: uppercase;
  line-height: 1.5rem;
}
.pos-list-item .pos-details .pos-name .pos-city {
  color: var(--123-green);
  font-weight: bold;
}

.pos-list-item .pos-details .pos-name .pos-city.pos-city--selected {
  color: #ffffff;
}
.pos-list-item .pos-details .pos-address {
  font-family: Muli;
  font-size: .875rem;
  line-height: 1.2rem;
}
.pos-list-item .pos-details .pos-phone {
  line-height: 1.2rem;
}
@media screen and (max-width: 720px) {
  .pos-list-item .pos-details .book-button {
    height: 2.5rem;
  }
}

.pos-list-item .pos-details .pos-rate .stars {
  font-size: .5rem;
  line-height: .75rem;
  text-align: right;
}
.pos-list-item .pos-details .pos-rate .stars .pi {
  color: var(--yellow-400);
}
.pos-list-item .pos-details .pos-rate .pos-rate-number {
  font-size: .75rem;
  line-height: 1rem;
  text-align: right;
  color: var(--text-color-secondary);
}
.pos-list-item .pos-info-icon {
  flex-grow: 0;
  flex-basis: 10%;
  background-color: var(--123-green);
  color: #FFF;
  cursor: pointer;
}

.pos-info-icon:hover .pi {
  color: #000;
}

.pos-list-item.selected .pos-details {
  background-color: var(--123-green);
  color: #FFF;
  border-right: solid 1px var(--123-light-grey);
}
.pos-list-item.selected .pos-details .p-button.p-button-primary {
  background-color: #FFF;
  color: var(--123-green);
}
.pos-list-item.selected .pos-details .pos-rate .pos-rate-number {
  color: #FFF;
}
.pos-list-item.selected .pos-details .pos-distance {
  color: #000;
}
</style>
